import React, { useRef, useState, useEffect } from 'react';
import { savePedido } from '../../../services/PedidosService';
import SwitchInput from '../../../components/SwitchInput/SwitchInput';




/**
 * props:
 * - data
 * - onSubmit
 */
function PedidoModal( props) {


    // console.log(props.data)
    const [notification, setNotification] = useState({});
    const [error, setError] = useState('');

    const [Pedido, setPedido] = useState({});
    const [dtfinal, setDtFinal] = useState('');


    const btnClose = useRef('');
    const btnSave = useRef('');

    function onSubmit(event) {
        const token = localStorage.getItem('token');
        savePedido(Pedido.id, Pedido, token)
            .then(result => {
                btnClose.current.click();
                if (result)
                    setNotification({ type: 'success', text: `Settings updated successfully!` });
                else
                    setNotification({ type: 'error', text: `Can't update the settings.` });
                btnClose.current.click();
                if (props.onSubmit) props.onSubmit(result);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setError(err.response ? err.response.data : err.message);
            })
    }

    function onInputChange(event) {
        console.log('On imput change');
        setPedido(prevState => ({ ...prevState, [event.target.id]: event.target.value }));
    }

    useEffect(() => {

        setPedido(props.data);
    }, [props.data.id])


    function getDate(timestamp) {

        const date = new Date(timestamp);

        try {
            return Intl.DateTimeFormat('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short'
            })
                .format(date);
        } catch (error) {
            console.log(error);
        }

    }

    useEffect(() => {

        const dataFinal = getDate(Pedido.updatedAt);
        setDtFinal(dataFinal)

    })
    const styles = { width: "100%" };
    const data = dtfinal;

    return (
        <div className="modal fade" id="modalPedido" tabIndex="-1" role="dialog" aria-labelledby="modalTitleNotify" aria-hidden="false" data-bs-backdrop="static" data-bs-keyboard="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title" id="modalTitleNotify">{props.data.id ? 'Edit ' : 'New '}Pedido</p>
                        <button ref={btnClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">

                            
                            <div className="col-6 mb-3">
                                <div className="form-group">
                                    <label htmlFor="nome">Cliente:</label>
                                    <h3>   {props.data.user?.nome}</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="name">Total do pedido:</label>
                                        <input type="text" id="valor_total" className="form-control" onChange={onInputChange} defaultValue={Pedido.valor_total} placeholder="Total do Pedido" />
                                    </div>
                                </div>
                            </div>


                            <div className="row">




                                {/* Atualizado em  */}
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="phone">Atualizado:</label>
                                        <input type="text" id="updatedAt" className="form-control" defaultValue={data} placeholder="Telefone" disabled />
                                    </div>
                                </div>
                            </div>

                        
                            
                        
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <SwitchInput id="isPago" text="Pedido Pago?" onChange={onInputChange} isChecked={(Pedido.isPago)} />
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <SwitchInput id="isProcessado" text="Pedido processado?" onChange={onInputChange} isChecked={(Pedido.isProcessado)} />
                                    </div>
                                </div>
                            </div>

                            
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <SwitchInput id="isEntregue" text="Pedido entregue?" onChange={onInputChange} isChecked={(Pedido.isEntregue)} />
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <SwitchInput id="isActive" text="Is Active?" onChange={onInputChange} isChecked={(Pedido.isActive)} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="modal-footer">
                        {
                            error
                                ? <div className="alert alert-danger mt-1 col-9 py-1">{error}</div>
                                : <React.Fragment></React.Fragment>
                        }
                        <button ref={btnSave} type="button" className="btn btn-sm btn-primary" onClick={onSubmit}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PedidoModal;